import { render, staticRenderFns } from "./CurrencyTile.vue?vue&type=template&id=53142945&"
import script from "./CurrencyTile.vue?vue&type=script&lang=js&"
export * from "./CurrencyTile.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyTile.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports